// meta pixel code thankyou page
document.addEventListener("DOMContentLoaded", function(){

    let email = sessionStorage.getItem("email");
    let phone = sessionStorage.getItem("mobile");

    if(window.location.href.includes("thank") && email && phone) {

        // 🚀 Send only to Google Sheets
        storeInGoogleSheet().then(() => {
            sessionStorage.clear();
        });

        // ✅ Meta Pixel
        fbq('init', '180289639574442', {
            'em': email.toLowerCase(),
            'ph': '91' + phone
        });

        fbq('trackCustom','ThankYouPageAll');
        fbq('track','PageView');
    }

    // ==============================
    // GOOGLE SHEET SUBMISSION
    // ==============================
    async function storeInGoogleSheet() {

        let formBody = new FormData();

        for (let i = 0; i < sessionStorage.length; i++) {
            let key = sessionStorage.key(i);
            let value = sessionStorage.getItem(key);

            if(key.includes("contact")){
                formBody.append(key, value);
            }
        }

        const primarySheetURL = 'https://script.google.com/macros/s/AKfycbw_XxMle6fj9FFaCS82tutTkPKBjQ1bkTS_H_2w0UjF787YtZI3g8QQs3PXpzDJQyIPTw/exec';
        const secondarySheetURL = 'https://script.google.com/macros/s/AKfycbzogWQPGdTOJpySRYtluF1xbBf8_YDZX5Gwxu2FpLoWwLY2S6ADDoITzUhu5Hi_xOFCbA/exec';

        const postData = async (url, body) => {
            try {
                const controller = new AbortController();
                const timeout = setTimeout(() => controller.abort(), 3000);

                const response = await fetch(url, {
                    method: 'POST',
                    body: body,
                    signal: controller.signal
                });

                clearTimeout(timeout);

                const responseText = await response.text();
                console.log(`✅ Submission successful to: ${url}`, response.status);
                console.log("📩 Response:", responseText);

            } catch (error) {
                console.log(`⚠️ Submission failed to: ${url}`, error);
            }
        };

        console.log('📤 Sending data to Google Sheets');

        // Send to both sheets
        await Promise.all([
            postData(primarySheetURL, formBody),
            postData(secondarySheetURL, formBody)
        ]);

        console.log('✅ Sheet submission completed');
    }

});